import { render, staticRenderFns } from "./AdminSegmentExportMapping.vue?vue&type=template&id=5fe20bfc&"
import script from "./AdminSegmentExportMapping.vue?vue&type=script&lang=js&"
export * from "./AdminSegmentExportMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports